import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
    const [admin, setAdmin] = useState(null);  // null=checking, false=unauth, obj=auth
    const [token, setToken] = useState(() => localStorage.getItem("Kanganya_admin_token") || "");

    useEffect(() => {
        if (!token) { setAdmin(false); return; }
        api.get("/admin/me", { headers: { Authorization: `Bearer ${token}` } })
            .then((r) => setAdmin(r.data))
            .catch(() => { setAdmin(false); setToken(""); localStorage.removeItem("Kanganya_admin_token"); });
    }, [token]);

    const finishLogin = (data) => {
        localStorage.setItem("Kanganya_admin_token", data.token);
        setToken(data.token);
        setAdmin(data.admin);
        return data.admin;
    };

    // Step 1: sirf email. Server code bhejta hai aur { otp_required, challenge_id, sent_to } deta hai.
    const login = async (email) => {
        const { data } = await api.post("/admin/login", { email });
        return data;
    };

    // Step 2: email par aaya 6-digit code
    const verifyOtp = async (challengeId, otp) => {
        const { data } = await api.post("/admin/login/verify", { challenge_id: challengeId, otp });
        return finishLogin(data);
    };

    const logout = () => {
        localStorage.removeItem("Kanganya_admin_token");
        setToken("");
        setAdmin(false);
    };

    const authHeader = () => ({ Authorization: `Bearer ${token}` });

    return (
        <AdminAuthContext.Provider value={{ admin, token, login, verifyOtp, logout, authHeader }}>
            {children}
        </AdminAuthContext.Provider>
    );
};

export const useAdminAuth = () => {
    const ctx = useContext(AdminAuthContext);
    if (!ctx) throw new Error("useAdminAuth must be used within AdminAuthProvider");
    return ctx;
};